import oRequest from '@/libsV2/request.js';

const URL = {
    // PROJECT_LIST: 'project/index/lists',
    // PROJECT_LIST: 'project/index/listsv2',
    PROJECT_LIST: 'project/index/listsv3',
    PROJECT_LISTSOTHER: 'project/index/listsOtherv3',
    PROJECT_TOTAL_NUM: 'project/index/total',
    PROJECT_TOTAL_NUM_v2: 'project/index/totalv2',
    SEARCH_CONFIG: 'project/index/getconf',
    PROJECT_PLOTS: 'project/index/plots',
    PROJECT_PLOTS_V2: 'project/index/plotsv2',
    GOODS_LIST: 'shop.goods/lists',
    PLOTS_CASE: 'project/index/projectByplots',
    PLOTS_CASE_V2: 'project/index/projectByplotsv2',
    // ��ȡ����ID
    GET_CITY_ID: 'tool/Transition/index',
}

/**
 * ��ȡ����ID
 * @param data.cityName �Ϻ���
 * @param data.provinceName �Ϻ���
 * @param data.distintName �ζ���
 * @returns {Promise<unknown>}
 */
export const getCityIdByName = (data = {}) => {
    return oRequest.getData(URL.GET_CITY_ID, data)
}

export const getProjectList = (data = {}) => {
    return oRequest.getData(URL.PROJECT_LIST, data)
}

export const getProjectListsOther = (data = {}) => {
    return oRequest.getData(URL.PROJECT_LISTSOTHER, data)
}

export const getProjectTotalNum = (data = {}) => {
    return oRequest.getData(URL.PROJECT_TOTAL_NUM, data)
}
export const getProjectTotalNumV2 = (data = {}) => {
    return oRequest.getData(URL.PROJECT_TOTAL_NUM_v2, data)
}

export const getSearchConfig = (data = {}) => {
    return oRequest.getData(URL.SEARCH_CONFIG, data)
}

export const getProjectPlots = (data = {}) => {
    return oRequest.getData(URL.PROJECT_PLOTS, data)
}
export const getProjectPlotsV2 = (data = {}) => {
    return oRequest.getData(URL.PROJECT_PLOTS_V2, data)
}

// PLOTS_CASE
export const getPlotsCase = (data = {}) => {
    return oRequest.getData(URL.PLOTS_CASE, data)
}
export const getPlotsCaseV2 = (data = {}) => {
    return oRequest.getData(URL.PLOTS_CASE_V2, data)
}

export const getGoodsList = (data = {}) => {
    return oRequest.getData(URL.GOODS_LIST, data)
}
